import "~/css/app.css";
import {Router} from "@solidjs/router";
import AppRoot from "~/root";
import {FileRoutes} from "@solidjs/start/router";
import {MetaProvider} from "@solidjs/meta";

export default function App() {

    return (
        <MetaProvider>
            <Router root={AppRoot}>
                <FileRoutes/>
            </Router>
        </MetaProvider>
    );
}